import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { AuthGuard } from "../../guards/AuthGuard";
import { WorkspaceGuard } from "../../guards/WorkspaceGuard";
import Root from "../../../Root";
import HomeScreen from "../../../pages/home/Screens/HomeScreen";
import ComingSoonScreen from "../../../pages/ComingSoon/ComingSoonScreen";
import PageBuildingViewScreen from "../../../pages/AssetManagement/PageBuilder/PageBuildingViewScreen";
import PageBuildingEditScreen from "../../../pages/AssetManagement/PageBuilder/PageBuilding/PageBuildingEditScreen";
import AdvertisingAccountsScreen from "../../../pages/PaidTrafficManagement/AdvertisingAccounts/AdvertisingAccountsScreen";
import FinanceManualExpenseScreen from "../../../pages/FinanceManagement/ProviderExpense/ManualExpenses/FinanceManualExpenseScreen";
import FinanceManualExpenseDetailScreen from "../../../pages/FinanceManagement/ProviderExpense/ManualExpenses/FinanceManualExpenseDetailScreen";
import FinanceReceiptsScreen from "../../../pages/FinanceManagement/ProviderExpense/Receipts/FinanceReceiptsScreen";
import FinanceReceiptsPairScreen from "../../../pages/FinanceManagement/ProviderExpense/Receipts/FinanceReceiptsPairScreen";
import ETLSequenceScreen from "../../../pages/Admin/Processes/ETLSequences/ETLSequenceScreen";
import ETLProcessLogScreen from "../../../pages/Admin/Processes/ETLProcessLog/ETLProcessLogScreen";
import ETLProcessListScreen from "../../../pages/Admin/Processes/ETLProcessList/ETLProcessListScreen";
import ETLLogLogResponseScreen from "../../../pages/Admin/Processes/ETLProcessLog/ETLLogLogResponseScreen";
import WebsitePageGroupScreen from "../../../pages/AssetManagement/WebsitePageGroup/WebsitePageGroupScreen";
import CompetitorsPageSpeedScreen from "../../../pages/MarketPositioning/Scout/CompetitorsPageSpeed/CompetitorsPageSpeedScreen";
import PageSpeedPerformanceScreen from "../../../pages/AssetManagement/Health/PageSpeedPerformance/PageSpeedPerformanceScreen";
import MonitoringScreen from "../../../pages/AssetManagement/Health/Monitoring/MonitoringScreen";
import TemplatesScreen from "../../../pages/AssetManagement/Design/Templates/TemplatesScreen";
import CreateTemplateScreen from "../../../pages/AssetManagement/Design/Templates/CreateTemplateScreen";
import EditTemplateScreen from "../../../pages/AssetManagement/Design/Templates/EditTemplateScreen";
import EngagementIncentives from "../../../components/Paid Traffic/EngagementIncentives/EngagementIncentives";
import ThemeScreen from "../../../pages/AssetManagement/Design/Theme/ThemeScreen";
import CreateNewThemeScreen from "../../../pages/AssetManagement/Design/Theme/CreateNewThemeScreen";
import EditThemeScreen from "../../../pages/AssetManagement/Design/Theme/EditThemeScreen";
import MetaEntitiesScreen from "../../../pages/Admin/MetaEntities/MetaEntitiesScreen";
import DataStoreRequestScreen from "../../../pages/Admin/DataStoreRequest/DataStoreRequestScreen";
import LoginScreen from "../../../pages/Login/screens/LoginScreen";
import LogoutScreen from "../../../pages/Logout/LogoutScreen";
import ResetPasswordScreen from "../../../pages/ResetPassword/screen/ResetPasswordScreen";
import ConfirmPasswordScreen from "../../../pages/ResetPassword/ConfirmPasswordScreen";
import Page404 from "../../../components/Page404/Page403";
import TrendsBreakdownScreen from "../../../pages/AssetManagement/Overview/Trends/TrendsBreakdownScreen";
import CreateMapScreen from "../../../pages/DataCollection/Unifier/Maps/CreateMapScreen";
import DuplicateMapsScreen from "../../../pages/DataCollection/Unifier/Maps/DuplicateMapsScreen";
import EditMapsScreen from "../../../pages/DataCollection/Unifier/Maps/EditMapsScreen";
import MapsInsightScreen from "../../../pages/DataCollection/Unifier/Maps/MapsInsightScreen";
import MapsScreen from "../../../pages/DataCollection/Unifier/Maps/MapsScreen";
import CalculationTypesScreen from "../../../pages/DataCollection/Unifier/CalculationTypes/CalculationTypesScreen";
import DuplicateDefinitionScreen from "../../../pages/DataCollection/Unifier/UniqueDefinitions/DuplicateDefinitionScreen";
import EditDefinitionScreen from "../../../pages/DataCollection/Unifier/UniqueDefinitions/EditDefinitionScreen";
import CreateNewDefinitionScreen from "../../../pages/DataCollection/Unifier/UniqueDefinitions/CreateNewDefinitionScreen";
import UniqueDefinitionsScreen from "../../../pages/DataCollection/Unifier/UniqueDefinitions/UniqueDefinitionsScreen";
import DataCollectionProcesLogsScreen from "../../../pages/DataCollection/Monitoring/DataCollectionProcessLogsScreen";
import DataCollectionPackagesScreen from "../../../pages/DataCollection/Monitoring/DataCollectionPackagesScreen";
import BrandConfiguration from "../../../components/Partners/DataIntegrations/BrandConfigurationReport/BrandConfigurationReport";
import DataStoreReqQueryNameScreen from "../../../pages/Admin/DataStoreRequest/DataStoreReqQueryNameScreen";
import EditDataStoreRequest from "../../../components/Admin/DatastoreRequests/CreateAndEditDataStoreRequest/EditDataStoreRequest";
import CreateDataStoreRequest from "../../../components/Admin/DatastoreRequests/CreateAndEditDataStoreRequest/CreateDataStoreRequest";
import DataStoreRequestRunQuery from "../../../components/Admin/DatastoreRequests/DataStoreRequestRunQuery/DataStoreRequestRunQuery";
import WebsiteActionsScreen from "../../../pages/AssetManagement/WebsiteActions/WebsiteActionsScreen";
import WebsiteEditScreen from "../../../pages/AssetManagement/WebsiteActions/WebsiteEditScreen";
import WebsiteSettingScreen from "../../../pages/AssetManagement/WebsiteActions/WebsiteSettingScreen";
import BusinessLeaderDashboardScreen from "../../../pages/AssetManagement/Overview/BusinessLeaderDashboard/BusinessLeaderDashboardScreen";
import FtdLoadedFromTotalScreen from "../../../pages/AssetManagement/Overview/BusinessLeaderDashboard/FtdLoadedFromTotalScreen";
import TrendsScreen from "../../../pages/AssetManagement/Overview/Trends/TrendsScreen";
import WebsiteTargetScreen from "../../../pages/AssetManagement/Overview/WebsiteTarget/WebsiteTargetScreen";
import NewTargetScreen from "../../../pages/AssetManagement/Overview/WebsiteTarget/SetWebsiteTarget/NewTargetScreen";
import EditTargetScreen from "../../../pages/AssetManagement/Overview/WebsiteTarget/EditWebsiteTarget/EditTargetScreen";
import DataAccuracyScreen from "../../../pages/AssetManagement/Health/DataAccuracy/DataAccuracyScreen";
import TaskNameDataAccruracyScreen from "../../../pages/AssetManagement/Health/DataAccuracy/TaskNameDataAccruracyScreen";
import { OccurrencesDataAccruracyScreen } from "../../../pages/AssetManagement/Health/DataAccuracy/OccurrencesDataAccruracyScreen";
import ActionItemsScreen from "../../../pages/AssetManagement/Overview/ActionItems/ActionItemsScreen";
import ActionItemAdditionalInfoScreen from "../../../pages/AssetManagement/Overview/ActionItems/ActionItemAdditionalInfoScreen";
import BrandConfigurationReportScreen from "../../../pages/Partners/DataIntegrations/BrandConfigurationReport/BrandConfigurationReportScreen";
import BrandPropertiesScreen from "../../../pages/Partners/DataIntegrations/BrandConfigurationReport/BrandPropertiesScreen";
import InsightsScreen from "../../../pages/AssetManagement/Overview/Insights/InsightsScreen";
import InsightAdgroupScreen from "../../../pages/AssetManagement/Overview/Insights/InsightAdgroupScreen";
import InsightCampaignScreen from "../../../pages/AssetManagement/Overview/Insights/InsightCampaignScreen";
import LandingPageExperienceScreen from "../../../pages/PaidTrafficManagement/Methodology/LPExperience/LandingPageExperienceScreen";
import SearchTermOperationsScreen from "../../../pages/PaidTrafficManagement/Methodology/SearchTermOperations/SearchTermOperationsScreen";
import SingleLandingPageExpScreen from "../../../pages/PaidTrafficManagement/Methodology/LPExperience/SingleLandingPageExpScreen";
import BusinessActivityNotesScreen from "../../../pages/AssetManagement/ActivityNotes/BusinessActivityNotesScreen";
import BusinessActivityNotesDetailsScreen from "../../../pages/AssetManagement/ActivityNotes/BusinessActivityNotesDetailsScreen";
import PerformanceForeCasterScreen from "../../../pages/AssetManagement/Overview/ForeCaster/PerformanceForeCasterScreen";
import CreateNewForeCasteScreen from "../../../pages/AssetManagement/Overview/ForeCaster/CreateNewForeCasteScreen";
import ForeCasterInfoScreen from "../../../pages/AssetManagement/Overview/ForeCaster/ForeCasterInfoScreen";
import DuplicateForecastScreen from "../../../pages/AssetManagement/Overview/ForeCaster/DuplicateForecastScreen";
import MonthlySummaryScreen from "../../../pages/AssetManagement/Overview/ForeCaster/MonthlySummaryScreen";
import DataCollectionBrandsScreen from "../../../pages/DataCollection/Brands/DataCollectionBrandsScreen";
import { useSelector } from "react-redux";
import { selectUserData, selectUserToken } from "../../../features/userSlice";
import DesktopOnlyMessage from "../../../components/DesktopOnly/DesktopOnlyMessage";
import { useDeviceDetection } from "../../../customHooks/useDeviceDetection";
import WorkspaceLayout from "../shared/WorkspaceLayout";
import BizLeaderDashMobileScreen from "../../../pages/AssetManagement/Overview/BusinessLeaderDashboard/BizLeaderDashMobileScreen";
import TrendsMobileScreen from "../../../pages/AssetManagement/Overview/Trends/TrendsMobileScreen";

// Component wrapper that handles device-specific rendering
interface DeviceAwareComponentProps {
  desktopComponent: React.ComponentType<any>;
  mobileComponent?: React.ComponentType<any>;
  props?: Record<string, any>;
  screenName?: string;
  mobileAllowed?: boolean;
}

const DeviceAwareComponent = ({
  desktopComponent: DesktopComponent,
  mobileComponent: MobileComponent,
  props = {},
  screenName = "This screen",
  mobileAllowed = false,
}: DeviceAwareComponentProps) => {
  const { deviceType } = useDeviceDetection();
  const isDesktop = deviceType === "desktop";

  if (isDesktop) {
    return <DesktopComponent {...props} />;
  }

  // Mobile device
  if (mobileAllowed) {
    // If mobile is allowed and mobile component exists, use it
    if (MobileComponent) {
      return <MobileComponent {...props} />;
    }
    // If mobile is allowed but no mobile component, fall back to desktop component
    return <DesktopComponent {...props} />;
  }

  // Mobile not allowed
  return <DesktopOnlyMessage screenName={screenName} />;
};

export const DynamicRoot = () => {
  const selectUserResponse = useSelector(selectUserData)?.data;
  const userToken = useSelector(selectUserToken);

  const router = createBrowserRouter([
    {
      path: "/",
      element: <Root />,
      children: [
        {
          path: "/",
          element: (
            <AuthGuard>
              <WorkspaceGuard>
                <WorkspaceLayout />
              </WorkspaceGuard>
            </AuthGuard>
          ),
          children: [
            {
              path: "/",
              element: (
                <DeviceAwareComponent
                  desktopComponent={HomeScreen}
                  mobileComponent={HomeScreen}
                  mobileAllowed={true}
                  screenName="Home"
                />
              ),
              handle: { title: "Home" },
            },
            {
              path: "comingSoon",
              element: (
                <DeviceAwareComponent
                  desktopComponent={ComingSoonScreen}
                  mobileComponent={ComingSoonScreen}
                  screenName="Coming Soon"
                />
              ),
              handle: { title: "Coming Soon" },
            },
            {
              path: "performance/page_builder/",
              element: (
                <DeviceAwareComponent
                  desktopComponent={PageBuildingViewScreen}
                  screenName="Page Builder"
                />
              ),
              handle: { title: "Page Builder" },
            },
            {
              path: "performance/page_builder/edit",
              element: (
                <DeviceAwareComponent
                  desktopComponent={PageBuildingEditScreen}
                  props={{ userToken }}
                  screenName="Page Builder - Edit Page"
                />
              ),
              handle: { title: "Page Builder - Edit Page" },
            },
            {
              path: "operations/advertising-accounts/:siteName?",
              element: (
                <DeviceAwareComponent
                  desktopComponent={AdvertisingAccountsScreen}
                  props={{ userToken }}
                  screenName="Advertising Accounts"
                />
              ),
              handle: { title: "Advertising Accounts" },
            },
            {
              path: "performance/manual_expenses",
              element: (
                <DeviceAwareComponent
                  desktopComponent={FinanceManualExpenseScreen}
                  screenName="Manual Expenses"
                />
              ),
              handle: { title: "Manual Expenses" },
            },
            {
              path: "performance/manual_expenses/manual_expense_details",
              element: (
                <DeviceAwareComponent
                  desktopComponent={FinanceManualExpenseDetailScreen}
                  screenName="Manual Expense Detail"
                />
              ),
              handle: { title: "Manual Expense Detail" },
            },
            {
              path: "finance/receipts",
              element: (
                <DeviceAwareComponent
                  desktopComponent={FinanceReceiptsScreen}
                  screenName="Receipts"
                />
              ),
              handle: { title: "Receipts" },
            },
            {
              path: "finance/receipts/receipts_pairing",
              element: (
                <DeviceAwareComponent
                  desktopComponent={FinanceReceiptsPairScreen}
                  screenName="Receipts Pairing"
                />
              ),
              handle: { title: "Receipts Pairing" },
            },
            {
              path: "admin/etl-sequences",
              element: (
                <DeviceAwareComponent
                  desktopComponent={ETLSequenceScreen}
                  props={{ userToken }}
                  screenName="ETL Sequences"
                />
              ),
              handle: { title: "ETL Sequences" },
            },
            {
              path: "admin/etl-process-log",
              element: (
                <DeviceAwareComponent
                  desktopComponent={ETLProcessLogScreen}
                  props={{ userToken, response: selectUserResponse }}
                  screenName="ETL Log"
                />
              ),
              handle: { title: "ETL Log" },
            },
            {
              path: "admin/etl-process-list",
              element: (
                <DeviceAwareComponent
                  desktopComponent={ETLProcessListScreen}
                  props={{ userToken }}
                  screenName="ETL List"
                />
              ),
              handle: { title: "ETL List" },
            },
            {
              path: "admin/etl-process-log/etl-process-log-Response",
              element: (
                <DeviceAwareComponent
                  desktopComponent={ETLLogLogResponseScreen}
                  props={{ userToken }}
                  screenName="ETL Log Response"
                />
              ),
              handle: { title: "ETL Log Response" },
            },
            {
              path: "operations/page_groups",
              element: (
                <DeviceAwareComponent
                  desktopComponent={WebsitePageGroupScreen}
                  props={{ userToken }}
                  screenName="Page Groups"
                />
              ),
              handle: { title: "Page Groups" },
            },
            {
              path: "performance/competitors_page_speed",
              element: (
                <DeviceAwareComponent
                  desktopComponent={CompetitorsPageSpeedScreen}
                  props={{ userToken, response: selectUserResponse }}
                  screenName="Competitors Page Speed"
                />
              ),
              handle: { title: "Competitors Page Speed" },
            },
            {
              path: "operations/page_speed_performance/:siteName?",
              element: (
                <DeviceAwareComponent
                  desktopComponent={PageSpeedPerformanceScreen}
                  screenName="Page Speed Performance"
                />
              ),
              handle: { title: "Page Speed Performance" },
            },
            {
              path: "operations/monitoring",
              element: (
                <DeviceAwareComponent
                  desktopComponent={MonitoringScreen}
                  screenName="Monitoring"
                />
              ),
              handle: { title: "Monitoring" },
            },
            {
              path: "operations/templates",
              element: (
                <DeviceAwareComponent
                  desktopComponent={TemplatesScreen}
                  props={{ userToken, response: selectUserResponse }}
                  screenName="Templates"
                />
              ),
              handle: { title: "Templates" },
            },
            {
              path: "operations/templates/create_new_template/",
              element: (
                <DeviceAwareComponent
                  desktopComponent={CreateTemplateScreen}
                  screenName="Create New Template"
                />
              ),
              handle: { title: "Create New Template" },
            },
            {
              path: "operations/templates/edit_new_template",
              element: (
                <DeviceAwareComponent
                  desktopComponent={EditTemplateScreen}
                  screenName="Edit Template"
                />
              ),
              handle: { title: "Edit Template" },
            },
            {
              path: "business_development/incentives_traffic",
              element: (
                <DeviceAwareComponent
                  desktopComponent={EngagementIncentives}
                  screenName="Incentivised Traffic"
                />
              ),
              handle: { title: "Incentivised Traffic" },
            },
            {
              path: "operations/theme",
              element: (
                <DeviceAwareComponent
                  desktopComponent={ThemeScreen}
                  props={{ userToken, response: selectUserResponse }}
                  screenName="Themes"
                />
              ),
              handle: { title: "Themes" },
            },
            {
              path: "operations/theme/create_new_theme",
              element: (
                <DeviceAwareComponent
                  desktopComponent={CreateNewThemeScreen}
                  screenName="Create New Theme"
                />
              ),
              handle: { title: "Create New Theme" },
            },
            {
              path: "operations/theme/edit_new_theme",
              element: (
                <DeviceAwareComponent
                  desktopComponent={EditThemeScreen}
                  screenName="Edit Theme"
                />
              ),
              handle: { title: "Edit Theme" },
            },
            {
              path: "admin/meta_entities/",
              element: (
                <DeviceAwareComponent
                  desktopComponent={MetaEntitiesScreen}
                  props={{ userToken }}
                  screenName="Meta Entities"
                />
              ),
              handle: { title: "Meta Entities" },
            },
            {
              path: "admin/queries/",
              element: (
                <DeviceAwareComponent
                  desktopComponent={DataStoreRequestScreen}
                  screenName="Queries"
                />
              ),
              handle: { title: "Queries" },
            },
            {
              path: "admin/queries/query_view",
              element: (
                <DeviceAwareComponent
                  desktopComponent={DataStoreReqQueryNameScreen}
                  screenName="Queries - Query View"
                />
              ),
              handle: { title: "Queries - Query View" },
            },
            {
              path: "admin/queries/edit_query",
              element: (
                <DeviceAwareComponent
                  desktopComponent={EditDataStoreRequest}
                  screenName="Queries - Edit Query"
                />
              ),
              handle: { title: "Queries - Edit Query" },
            },
            {
              path: "admin/queries/create_query",
              element: (
                <DeviceAwareComponent
                  desktopComponent={CreateDataStoreRequest}
                  screenName="Queries - Create Query"
                />
              ),
              handle: { title: "Queries - Create Query" },
            },
            {
              path: "admin/queries/run_query",
              element: (
                <DeviceAwareComponent
                  desktopComponent={DataStoreRequestRunQuery}
                  screenName="Run Query"
                />
              ),
              handle: { title: "Run Query" },
            },
            {
              path: "operations/website_actions",
              element: (
                <DeviceAwareComponent
                  desktopComponent={WebsiteActionsScreen}
                  screenName="Website Actions"
                />
              ),
              handle: { title: "Website Actions" },
            },
            {
              path: "operations/website_actions/edit_website",
              element: (
                <DeviceAwareComponent
                  desktopComponent={WebsiteEditScreen}
                  screenName="Edit Website"
                />
              ),
              handle: { title: "Edit Website" },
            },
            {
              path: "operations/website_actions/website_setting",
              element: (
                <DeviceAwareComponent
                  desktopComponent={WebsiteSettingScreen}
                  screenName="Website Setting"
                />
              ),
              handle: { title: "Website Setting" },
            },
            // Business Leader Dashboard - AVAILABLE ON BOTH DEVICES
            {
              path: "business_leader/dashboard",
              element: (
                <DeviceAwareComponent
                  desktopComponent={BusinessLeaderDashboardScreen}
                  mobileComponent={BizLeaderDashMobileScreen}
                  props={{ userToken, response: selectUserResponse }}
                  mobileAllowed={true}
                  screenName="Business Leader Dashboard"
                />
              ),
              handle: { title: "Business Leader Dashboard" },
            },
            {
              path: "business_leader/dashboard/FTD_loaded_from_total",
              element: (
                <DeviceAwareComponent
                  desktopComponent={FtdLoadedFromTotalScreen}
                  screenName="% of FTD loaded from total"
                />
              ),
              handle: { title: "% of FTD loaded from total" },
            },
            {
              path: "business_leader/dashboard/QFTD_loaded_from_total",
              element: (
                <DeviceAwareComponent
                  desktopComponent={FtdLoadedFromTotalScreen}
                  screenName="% of QFTD loaded from total"
                />
              ),
              handle: { title: "% of QFTD loaded from total" },
            },
            {
              path: "business_leader/trends/",
              element: (
                <DeviceAwareComponent
                  desktopComponent={TrendsScreen}
                  mobileComponent={TrendsMobileScreen}
                  props={{ userToken, response: selectUserResponse }}
                  mobileAllowed={true}
                  screenName="Trends"
                />
              ),
              handle: { title: "Trends" },
            },
            {
              path: "business_leader/website_projection",
              element: (
                <DeviceAwareComponent
                  desktopComponent={WebsiteTargetScreen}
                  props={{ userToken }}
                  screenName="Website Projection"
                />
              ),
              handle: { title: "Website Projection" },
            },
            {
              path: "business_leader/website_projection/set_new_projection",
              element: (
                <DeviceAwareComponent
                  desktopComponent={NewTargetScreen}
                  props={{ userToken }}
                  screenName="Set New Projection"
                />
              ),
              handle: { title: "Set New Projection" },
            },
            {
              path: "business_leader/website_projection/edit_projection",
              element: (
                <DeviceAwareComponent
                  desktopComponent={EditTargetScreen}
                  props={{ userToken }}
                  screenName="Edit Projection"
                />
              ),
              handle: { title: "Edit Projection" },
            },
            {
              path: "operations/data_accuracy",
              element: (
                <DeviceAwareComponent
                  desktopComponent={DataAccuracyScreen}
                  screenName="Data Accuracy"
                />
              ),
              handle: { title: "Data Accuracy" },
            },
            {
              path: "operations/data_accuracy/task_name",
              element: (
                <DeviceAwareComponent
                  desktopComponent={TaskNameDataAccruracyScreen}
                  screenName="Task Name"
                />
              ),
              handle: { title: "Task Name" },
            },
            {
              path: "operations/data_accuracy/task_name/occurrences",
              element: (
                <DeviceAwareComponent
                  desktopComponent={OccurrencesDataAccruracyScreen}
                  screenName="Task Name - Occurrences"
                />
              ),
              handle: { title: "Task Name - Occurrences" },
            },
            {
              path: "tools/action_items",
              element: (
                <DeviceAwareComponent
                  desktopComponent={ActionItemsScreen}
                  screenName="Action Items"
                />
              ),
              handle: { title: "Action Items" },
            },
            {
              path: "tools/action_items/edit_action_item",
              element: (
                <DeviceAwareComponent
                  desktopComponent={ActionItemAdditionalInfoScreen}
                  screenName="Edit Action Item"
                />
              ),
              handle: { title: "Edit Action Item" },
            },
            {
              path: "operations/brand_configuration_report",
              element: (
                <DeviceAwareComponent
                  desktopComponent={BrandConfigurationReportScreen}
                  screenName="Brand Configuration Report"
                />
              ),
              handle: { title: "Brand Configuration Report" },
            },
            {
              path: "operations/brand_configuration_report/brand_properties",
              element: (
                <DeviceAwareComponent
                  desktopComponent={BrandPropertiesScreen}
                  screenName="Brand Properties"
                />
              ),
              handle: { title: "Brand Properties" },
            },
            {
              path: "performance/insights",
              element: (
                <DeviceAwareComponent
                  desktopComponent={InsightsScreen}
                  screenName="Insights"
                />
              ),
              handle: { title: "Performance Insights" },
            },
            {
              path: "performance/insights/Adgroup",
              element: (
                <DeviceAwareComponent
                  desktopComponent={InsightAdgroupScreen}
                  screenName="Insights - Adgroup"
                />
              ),
              handle: { title: "Insights - Adgroup" },
            },
            {
              path: "performance/insights/Campaign",
              element: (
                <DeviceAwareComponent
                  desktopComponent={InsightCampaignScreen}
                  screenName="Insights - Campaign"
                />
              ),
              handle: { title: "Insights - Campaign" },
            },
            {
              path: "performance/landing_page_experience",
              element: (
                <DeviceAwareComponent
                  desktopComponent={LandingPageExperienceScreen}
                  screenName="Landing Page Experience"
                />
              ),
              handle: { title: "Landing Page Experience" },
            },
            {
              path: "performance/search_term_operations",
              element: (
                <DeviceAwareComponent
                  desktopComponent={SearchTermOperationsScreen}
                  screenName="Search Term Operations"
                />
              ),
              handle: { title: "Search Term Operations" },
            },
            {
              path: "performance/landing_page_experience/analysis",
              element: (
                <DeviceAwareComponent
                  desktopComponent={SingleLandingPageExpScreen}
                  screenName="Landing Page Experience - Analysis"
                />
              ),
              handle: { title: "Landing Page Experience - Analysis" },
            },
            {
              path: "tools/activity_notes",
              element: (
                <DeviceAwareComponent
                  desktopComponent={BusinessActivityNotesScreen}
                  screenName="Business Activity Notes"
                />
              ),
              handle: { title: "Business Activity Notes" },
            },
            {
              path: "tools/activity_notes/activity_note_details",
              element: (
                <DeviceAwareComponent
                  desktopComponent={BusinessActivityNotesDetailsScreen}
                  screenName="Activity Note Details"
                />
              ),
              handle: { title: "Activity Note Details" },
            },
            {
              path: "business_leader/forecaster",
              element: (
                <DeviceAwareComponent
                  desktopComponent={PerformanceForeCasterScreen}
                  screenName="Performance Forecaster"
                />
              ),
              handle: { title: "Performance Forecaster" },
            },
            {
              path: "business_leader/forecaster/Createnewforecast",
              element: (
                <DeviceAwareComponent
                  desktopComponent={CreateNewForeCasteScreen}
                  screenName="Create New Forecast"
                />
              ),
              handle: { title: "Create New Forecast" },
            },
            {
              path: "business_leader/forecaster/forecasterInfo",
              element: (
                <DeviceAwareComponent
                  desktopComponent={ForeCasterInfoScreen}
                  screenName="Forecaster Info"
                />
              ),
              handle: { title: "Forecaster Info" },
            },
            {
              path: "business_leader/forecaster/DuplicateForecast",
              element: (
                <DeviceAwareComponent
                  desktopComponent={DuplicateForecastScreen}
                  screenName="Duplicate Forecast"
                />
              ),
              handle: { title: "Duplicate Forecast" },
            },
            {
              path: "business_leader/forecaster/forecasterInfo/MonthlySummery",
              element: (
                <DeviceAwareComponent
                  desktopComponent={MonthlySummaryScreen}
                  screenName="Forecaster Info - Monthly Summary"
                />
              ),
              handle: { title: "Forecaster Info - Monthly Summary" },
            },
            {
              path: "business_leader/forecaster/DuplicateForecast/MonthlySummery",
              element: (
                <DeviceAwareComponent
                  desktopComponent={MonthlySummaryScreen}
                  screenName="Duplicate Forecast - Monthly Summary"
                />
              ),
              handle: { title: "Duplicate Forecast - Monthly Summary" },
            },
            {
              path: "business_leader/forecaster/Createnewforecast/MonthlySummery",
              element: (
                <DeviceAwareComponent
                  desktopComponent={MonthlySummaryScreen}
                  screenName="Create New Forecast - Monthly Summary"
                />
              ),
              handle: { title: "Create New Forecast - Monthly Summary" },
            },
            {
              path: "data_collection/brand_data",
              element: (
                <DeviceAwareComponent
                  desktopComponent={DataCollectionBrandsScreen}
                  screenName="Brand Data"
                />
              ),
              handle: { title: "Brand Data" },
            },
            {
              path: "data_collection/brand_data/process_logs",
              element: (
                <DeviceAwareComponent
                  desktopComponent={BrandConfiguration}
                  screenName="Brand Data - Process Logs"
                />
              ),
              handle: { title: "Brand Data - Process Logs" },
            },
            {
              path: "data_collection/data_workflows",
              element: (
                <DeviceAwareComponent
                  desktopComponent={DataCollectionPackagesScreen}
                  screenName="Data Workflows"
                />
              ),
              handle: { title: "Data Workflows" },
            },
            {
              path: "data_collection/data_logs",
              element: (
                <DeviceAwareComponent
                  desktopComponent={DataCollectionProcesLogsScreen}
                  screenName="Data Logs"
                />
              ),
              handle: { title: "Data Logs" },
            },
            {
              path: "data_collection/unique_definitions",
              element: (
                <DeviceAwareComponent
                  desktopComponent={UniqueDefinitionsScreen}
                  screenName="Unique Definitions"
                />
              ),
              handle: { title: "Unique Definitions" },
            },
            {
              path: "data_collection/unique_definitions/create_new_definition",
              element: (
                <DeviceAwareComponent
                  desktopComponent={CreateNewDefinitionScreen}
                  screenName="Create Unique Definition"
                />
              ),
              handle: { title: "Create Unique Definition" },
            },
            {
              path: "data_collection/unique_definitions/edit_definition",
              element: (
                <DeviceAwareComponent
                  desktopComponent={EditDefinitionScreen}
                  screenName="Edit Unique Definition"
                />
              ),
              handle: { title: "Edit Unique Definition" },
            },
            {
              path: "data_collection/unique_definitions/duplicate_definition",
              element: (
                <DeviceAwareComponent
                  desktopComponent={DuplicateDefinitionScreen}
                  screenName="Duplicate Unique Definition"
                />
              ),
              handle: { title: "Duplicate Unique Definition" },
            },
            {
              path: "data_collection/calculation_types",
              element: (
                <DeviceAwareComponent
                  desktopComponent={CalculationTypesScreen}
                  screenName="Calculation Types"
                />
              ),
              handle: { title: "Calculation Types" },
            },
            {
              path: "data_collection/unifier_maps",
              element: (
                <DeviceAwareComponent
                  desktopComponent={MapsScreen}
                  screenName="Maps"
                />
              ),
              handle: { title: "Maps" },
            },
            {
              path: "data_collection/unifier_maps/insight",
              element: (
                <DeviceAwareComponent
                  desktopComponent={MapsInsightScreen}
                  screenName="Maps Insight"
                />
              ),
              handle: { title: "Maps Insight" },
            },
            {
              path: "data_collection/unifier_maps/edit_map",
              element: (
                <DeviceAwareComponent
                  desktopComponent={EditMapsScreen}
                  screenName="Edit Map"
                />
              ),
              handle: { title: "Edit Map" },
            },
            {
              path: "data_collection/unifier_maps/duplicate_map",
              element: (
                <DeviceAwareComponent
                  desktopComponent={DuplicateMapsScreen}
                  screenName="Duplicate Map"
                />
              ),
              handle: { title: "Duplicate Map" },
            },
            {
              path: "data_collection/unifier_maps/create_new_map",
              element: (
                <DeviceAwareComponent
                  desktopComponent={CreateMapScreen}
                  screenName="Create New Map"
                />
              ),
              handle: { title: "Create New Map" },
            },
            {
              path: "/business_leader/trends/breakdown",
              element: (
                <DeviceAwareComponent
                  desktopComponent={TrendsBreakdownScreen}
                  screenName="Trends Breakdown"
                />
              ),
              handle: { title: "Trends Breakdown" },
            },
          ],
        },
        {
          path: "/login",
          element: <LoginScreen />,
          handle: { title: "Login" },
        },
        {
          path: "/logout",
          element: <LogoutScreen />,
          handle: { title: "Logout" },
        },
        {
          path: "/reset-password",
          element: <ResetPasswordScreen />,
          handle: { title: "Reset Password" },
        },
        {
          path: "/password/reset/confirm/:uid/:token",
          element: <ConfirmPasswordScreen />,
          handle: { title: "Confirm Password" },
        },
        {
          path: "/404",
          element: <Page404 />,
          handle: { title: "Page 404" },
        },
        {
          path: "*",
          element: <Page404 />,
          handle: { title: "Page Not Found" },
        },
      ],
    },
  ]);

  return <RouterProvider router={router} />;
};
